<template>
    <div class="flex items-center">
      <span
        class="inline-block mr-1"
        v-html="params.data.currency_code"
      ></span>
      {{ params.data.grand_total }}
    </div>
</template>

<script>
export default {
  name: 'AmountCell'
}
</script>